import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
} from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';

import Select from 'react-select';

import MyPagination from 'Components/MyPagination'
import dayjs from 'dayjs';
import * as XLSX from 'xlsx'

import Footer from 'Components/Footer';
import TabsIcon from 'MiddleSystems/Components/layout/TabsIcon';
import ReportImage from 'assets/icon/report-menu.png'
import Back from 'assets/icon/back.png';
// image
import CALENDAR from 'assets/icon/Calendar.png';

import { useDispatch, useSelector } from 'react-redux';
//API
// import { loadAuth } from 'actions/auth';
import { LoadProductCostReport } from 'actions/reports/index'

import { DatePicker } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import SearchImage from 'assets/icon/search.png';

import { loadAuth } from 'actions/auth';


export default function Stock() {
  const history = useHistory();
  const dispatch = useDispatch();

  const permission = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : null;
  const { log_permissions } = useSelector( (state) => state.user.permissions)
  const report_permission = log_permissions.find(item => item.permission.name === 'รายงาน' && item.middle === permission.middle)

  const { RangePicker } = DatePicker;

  const [Search, setSearch] = useState({
    Keyword: null,
    PerPage: 10,
    CurrentPage: 1,
    Rows: 0,
    Type: '',

  })

	const getAuth = async () => {
    try {
      const params = {
        name: ['รายงานต้นทุนสินค้า'],
        permission : 'view',
      }
      const response = await dispatch(loadAuth(params));
      if(response.data.data === 'Unauthorized'){
        alert(response.data.message)
        history.push('/report');
      }
    } catch (error) {
      history.push('/report');
      console.error(error);
    }
  };

	function unitSales(item){
		let text = ''
		item.product.unit_sales.map((u) => {
			text = text + u.name_sale + "\n"
		})
		return text;
	}

	function unitSalesPrice(item){
		let text = ''
		item.product.unit_sales.map((u) => {
			text = text + numeral(u.pivot.price).format('0,0.00') + "\n"
		})
		return text;
	}

	function CalDiff(item){
		let text = ''
		item.product.unit_sales.map((u) => {
			text = text + numeral(item.unit_price - u.pivot.price).format('0,0.00') + "\n"
		})
		return text;
	}

  const [errors, setErrors] = useState([]);
  const ExportExcel = () => {
    const params = {
      Keyword: Search.Keyword,
      page: 1,
      status: Search.Type,
    }

    dispatch(LoadProductCostReport(params)).then(response => {
      if (response.data.data && !response.data.data.length) {
        setErrors(['ไม่พบการนัดหมายที่เลือก'])
        return false
      }
      let data = [];
      let export_name = [];
      response.data.data.map( (item, key) => {
        let set = {
          'ลำดับ': key + 1 ,

          'วันที่ออกใบสั่งซื้อ': `${moment(item.created_at).format('YYYY-MM-DD')}`,
          'รหัสสินค้า': `${item.product.code}`,
          'ชื่อสินค้า': `${item.name}`,
          'หน่วยซื้อ': `${item.product.unit.name_buy}`,
          'ราคาต่อหน่วยที่สั่งซื้อ': `${numeral(item.unit_price).format('0,0.00')}`,
          'หน่วยขาย': `${unitSales(item)}`,
          'ราคาต่อหน่วยที่ขาย': `${unitSalesPrice(item)}`,
          'ส่วนต่างกำไร': `${CalDiff(item)}`,
					
        }
        export_name = `ProductCostReport - ${dayjs(item.created_at).format('DD-MM-YYYY')} `

        data.push(set);
      })
      const dataWS = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, export_name + '.xlsx')
    }).catch(e => {
      setErrors(['เกิดข้อผิดพลาด'])
    })
  }

  const [Loading,setLoading] = useState(false);

  const [ReportStock,setReportStock] = useState([])

  const [Pages, setPage] = useState([
    { value: null, label: 'ทั้งหมด' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
  ]);


  const getReportStock = async () => {
    try {
      const params = {
        Keyword: Search.Keyword,
        limit: Search.PerPage,
        page: Search.CurrentPage,
        status: Search.Type,
      };
      const response = await dispatch(LoadProductCostReport(params));
      if(Search.PerPage > 0){
        setReportStock(response.data.data.data);
        setSearch({ ...Search, 
          Rows: response.data.data.last_page,
          CurrentPage: response.data.data.current_page 
        })
        setLoading(false);
      }else{
        setReportStock(response.data.data);
        setSearch({ ...Search, 
          Rows: 0,
          CurrentPage: 1 
        })
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  }


  useEffect( () =>{
    getAuth()
    getReportStock();
  },[Search.Date,Search.PerPage,Search.CurrentPage,Search.Type]);

  function close() {
    history.push(`/report`);
  }
  return (
    <>
      <Container
        fluid
        className="package-container Service Stock Bill Report bg-mrk"
      >
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={ReportImage} />
                  <b>
                      <Link to={`/report`} className='mr-2'>รายงาน</Link>
                      &gt; รายงานต้นทุนสินค้า
                    </b>
                </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={close}
                  >
                    <span aria-hidden="true">X</span>
                  </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={close}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={ReportImage} />
                  <b>
                      <Link to={`/report`} className='mr-2'>รายงาน</Link>
                      &gt; รายงานต้นทุนสินค้า
                    </b>
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0">
                  <Col
                    lg={5}
                    xl={4}
                    className="d-flex justify-content-center mt-2 mb-2"
                  >
										<Form.Control
											className="input"
											type="text"
											placeholder="ค้นหาด้วยทะเบียนรถ"
											value={Search.Keyword ? Search.Keyword : ''}
											onChange={(e) => setSearch({ ...Search, Keyword: e.target.value })}
										></Form.Control>
                  </Col>
									<Col xs={6} lg={2} className="mt-2 mb-2">
										<Button
											className="button-menu"
											style={{ padding: 0, margin: 0 }}
											onClick={() => getReportStock()}
										>
											ค้นหา &nbsp;
											<img src={SearchImage} alt="" />
										</Button>
									</Col>
                  <Col
                    lg={5}
                    xl={4}
                    className="d-flex justify-content-center mt-2 mb-2"
                  >
                    <Button type="button" className="button" onClick={() => ExportExcel()}>
                      Export
                    </Button>
                  </Col>
                  
                </Row>

                <Row className="g-0 justify-content-center mt-3 m-0">
                  <Col className="set-table p-0">
                    <table className="table table-responsive table-wash-part ">
                      <thead>
                        <tr className="t-header-package">
                          <th>วันที่ออกใบสั่งซื้อ</th>
                          <th>รหัสสินค้า</th>
                          <th>ชื่อสินค้า</th>
                          <th>หน่วยซื้อ</th>
                          <th>ราคาต่อหน่วยที่สั่งซื้อ</th>
                          <th>หน่วยขาย</th>
                          <th>ราคาต่อหน่วยที่ขาย</th>
                          <th>ส่วนต่างกำไร</th>
                        </tr>
                      </thead>
                      <tbody className="t-body-package ">
                        {
                          ReportStock?.map((item,index) => {
                            return(
                              <tr key={item.id}>
                                <td>{ moment(item.created_at).format('YYYY-MM-DD') }</td>
                                <td>{ item.product.code }</td>
                                <td>{ item.name}</td>
                                <td>{ item.product.unit.name_buy}</td>
                                <td>{ numeral(item.unit_price).format('0,0.00')}</td>
                                <td>{ item.product.unit_sales.map((u) => {
																	return(
																		<p>{ u.name_sale }</p>
																	)
																}) }</td>
																<td>{ item.product.unit_sales.map((u) => {
																	return(
																		<p>{  numeral(u.pivot.price).format('0,0.00') }</p>
																	)
																}) }</td>
																<td>{ item.product.unit_sales.map((u) => {
																	return(
																		<p>{  numeral(item.unit_price - u.pivot.price).format('0,0.00') }</p>
																	)
																}) }</td>
                              </tr> 
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <Row className="g-0 mt-5 ">
            <Col lg={4} className=" set-page">
              <Row>
                <Col className="d-flex justify-content-center align-items-center">
                  <p style={{ margin: 0 }}>แสดง</p>
                </Col>
                <Col lg={7}>
                  <Select
                    className="text-left select-style"
                    aria-label="Default select example"
                    options={Pages}
                    onChange={(data) => setSearch({ ...Search, PerPage: data.value })}
                    defaultValue={{ value: 10, label: '10' }}
                  />
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <p style={{ margin: 0 }}>รายการ</p>
                </Col>
              </Row>
            </Col>

            <Col className="d-flex justify-content-end set-paginate">
              <div className="box-paginate">
                {
                  !Loading ? 
                    Search.Rows > 1 && Search.PerPage > 0 ?
                      <MyPagination totPages={Search.Rows} currentPage={Search.CurrentPage} pageClicked={(e) => { setSearch({...Search, CurrentPage: e }) }}></MyPagination> 
                    : ''
                  : 
                    Search.Rows > 1 && Search.PerPage > 0 ?
                      <MyPagination totPages={Search.Rows} currentPage={Search.CurrentPage} pageClicked={(e) => { setSearch({...Search, CurrentPage: e }) }}></MyPagination> 
                    : ''
                }
              </div>
            </Col>
          </Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
